import { USER_PREFERENCES_QUERY_KEY } from "@frontend-shared/constants";
import type { IUserPreferences } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { userApi } from "@/api/services";

import type { IUpdateUserPreferencesProps } from "./useUserPreferences";
import { updateUserPreferences } from "./useUserPreferences";

export const useUpdateUserPreferences = (
  props: Omit<IUpdateUserPreferencesProps, "payload">,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: IUserPreferences) =>
      userApi.updateUserPreferences(params),
    onMutate: (variables) => {
      updateUserPreferences({ ...props, payload: variables });
    },
    onSuccess: (data) => {
      if (data) {
        queryClient.setQueryData([USER_PREFERENCES_QUERY_KEY], data);
      }
    },
  });
};
